export default __webpack_public_path__ + "static/media/offer3.09d29407.jpg";